<template>
  <div v-if="disabled" class="button-container-div gray">

    <div class="button-class-div" v-if="buttonType == 'emptyBlue'">
      <slot>{{ $t('buttonStyle.emptyContent') }}</slot>
    </div>

    <div class="button-class-div" v-else-if="buttonType == 'fullBlue'">
      <slot>{{ $t('buttonStyle.emptyContent') }}</slot>
    </div>

  </div>

  <div v-else class="button-container-div" :style="currentStyle" @mouseenter="mouseEnterF" @mouseleave="mouseLeaveF" @click="clickButton">

    <div class="button-class-div" v-if="buttonType == 'emptyBlue'">
      <slot>{{ $t('buttonStyle.emptyContent') }}</slot>
    </div>

    <div class="button-class-div" v-else-if="buttonType == 'fullBlue'">
      <slot>{{ $t('buttonStyle.emptyContent') }}</slot>
    </div>
  </div>
</template>

<script>
    export default {
      name: "button-style-component",
      props:{
        buttonType:{
          default:"emptyBlue"
        },
        buttonStyle:{
            default:"",
        },
        disabled:{
          defalut:"",
        }
      },
      data(){
        return {
          currentStyle:{},
        }
      },
      beforeMount:function () {
        this.currentStyle = this.initStyle();
      },
      methods:{
          /*鼠标点击事件*/
        clickButton:function () {
          this.$emit("clickCallBack");
        },
        /*鼠标移入事件*/
        mouseEnterF:function () {
          var tempCss = this.styleDeal(this.buttonStyle);

          var tempStyle = this.initStyle();

          if(this.buttonType == "fullBlue") {
            if (tempCss.themeColor) {
              tempStyle.border = "1px solid " + tempCss.themeColor;
              tempStyle.color = tempCss.themeColor;
              tempStyle.backgroundColor = "#ecf8ff";
            }else {
              tempStyle.border = "1px solid #3d7ea1";
              tempStyle.color = "#3d7ea1";
              tempStyle.backgroundColor = "#ecf8ff";
            }
          }else{
            if (tempCss.themeColor) {
              tempStyle.border = "1px solid " + tempCss.themeColor;
              tempStyle.color = "white";
              tempStyle.backgroundColor = tempCss.themeColor;
            }else{
              tempStyle.border = "1px solid #3d7ea1";
              tempStyle.color = "white";
              tempStyle.backgroundColor = "#3d7ea1";
            }
          }

          this.currentStyle = tempStyle;
        },
        /*鼠标移楚事件*/
        mouseLeaveF:function () {
          this.currentStyle = this.initStyle();
        },
        initStyle:function () {
          var tempCss = this.styleDeal(this.buttonStyle);

          var tempStyle = {};

          /*修改宽度*/
          if(tempCss.width){
            tempStyle.width = tempCss.width;
          }

          /*修改高度*/
          if(tempCss.height){
            tempStyle.height = tempCss.height;
          }

          /*修改行高*/
          if(tempCss.lineHeight){
            tempStyle.lineHeight = tempCss.lineHeight;
          }

          /*根据按钮类型，修改 背景色 字色 border*/
          if(this.buttonType == "fullBlue"){
            if(tempCss.themeColor){
              tempStyle.border ="1px solid "+tempCss.themeColor;
              tempStyle.color = "#ffffff";
              tempStyle.backgroundColor = tempCss.themeColor;
            }else{

              tempStyle.border = "1px solid #3d7ea1";
              tempStyle.color = "white";
              tempStyle.backgroundColor = "#3d7ea1";
            }
          }else{
            if(tempCss.themeColor){
              tempStyle.border ="1px solid "+tempCss.themeColor;
              tempStyle.color = tempCss.themeColor;
              tempStyle.backgroundColor = "#ecf8ff";
            }else{
              tempStyle.border = "1px solid #3d7ea1";
              tempStyle.color = "#3d7ea1";
              tempStyle.backgroundColor = "#ecf8ff";
            }
          }

          /*修改margin left*/
          if(tempCss.marginLeft){
            tempStyle.marginLeft = tempCss.marginLeft;
          }

          /*修改 margin right*/
          if(tempCss.marginRight){
            tempStyle.marginRight = tempCss.marginRight;
          }

          /*修改border radius*/
          if(tempCss.borderRadius){
            tempStyle.borderRadius = tempCss.borderRadius;
          }

          /*修改padding 值*/
          if(tempCss.padding){
            tempStyle.padding = tempCss.padding;
          }

          /*修改display 样式*/
          if(tempCss.display){
            tempStyle.display = tempCss.display;
            tempStyle.alignItems = "center";
            tempStyle.justifyContent = "center";
          }

          return tempStyle;
        },
        /*处理 style 数据
       * 字符串样式修改为 样式对象 {fontSize:'16px'}
       * */
        styleDeal:function (inputStyle) {
          var styleObJ = {};
          if(inputStyle){
            var style = inputStyle.split(";");
            for(var i=0;i<style.length;i++){
              var tempData = style[i].split(":");
              styleObJ[tempData[0]] = tempData[1]
            }
          }
          return styleObJ;
        }
      }
    }
</script>

<style scoped>
  .button-container-div{
    width: 111px;
    height: 37px;
    line-height: 37px;
    display: inline-block;
    background-color: #ecf8ff;
    border: 1px solid #4876a1;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    user-select: none;
    border-radius: 4px;
  }
  .button-class-div{
    width: 100%;
  }
  .button-container-div:hover{
    background-color: #3d7ea1;
    color: white;
  }
  .gray{
    background-color: #ccc !important;
    color: #fff !important;
    border-color: #847676;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/buttonStyleComponent.vue